import React from 'react';

const CrossChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M13.4 12l3.5-3.5-1.4-1.4-3.5 3.5-3.5-3.5-1.4 1.4 3.5 3.5-3.5 3.5 1.4 1.4 3.5-3.5 3.5 3.5 1.4-1.4z" />
    </svg>
);

CrossChunkySvg.displayName = 'CrossChunkySvg';
export default CrossChunkySvg;
